import { resolveRestaurantTimezone } from './filterCategories';
import { RESTAURANT_SETTINGS } from '../config/restaurantSettings';

function getMinutes(timeStr) {
  const [h, m] = String(timeStr).trim().split(':').map(Number);
  return h * 60 + m;
}

export function getTodayHoursState(hoursData) {
  if (!hoursData?.time_zone) {
    return { isOpen: false, inBreak: false };
  }

  const timeZone = resolveRestaurantTimezone(hoursData.time_zone);
  const now = new Date();
  const currentDay = now.toLocaleString('en-US', { timeZone, weekday: 'long' }).toLowerCase();
  const todayHours = hoursData[currentDay];

  if (!todayHours || todayHours.toLowerCase() === 'closed') {
    return { isOpen: false, inBreak: false };
  }

  const [openClose, breakTime] = todayHours.split('|');
  const [openStr, closeStr] = openClose.split('-');
  const [breakStartStr, breakEndStr] = breakTime?.split('-') || [];

  const currentTime = now.toLocaleTimeString('en-US', {
    timeZone,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
  });

  const nowMinutes = getMinutes(currentTime);
  const openMinutes = getMinutes(openStr);
  const closeMinutes = getMinutes(closeStr);

  let inBreak = false;
  if (breakStartStr && breakEndStr) {
    const breakStartMinutes = getMinutes(breakStartStr);
    const breakEndMinutes = getMinutes(breakEndStr);
    inBreak = nowMinutes >= breakStartMinutes && nowMinutes < breakEndMinutes;
  }

  const isOpen =
    nowMinutes >= openMinutes &&
    nowMinutes <= closeMinutes &&
    !inBreak;

  return {
    isOpen,
    inBreak,
    nowMinutes,
    openMinutes,
    closeMinutes,
  };
}

export function isRestaurantOpen(hoursData) {
  return getTodayHoursState(hoursData).isOpen === true;
}

/** Delivery stops this many minutes before store close (pickup may still be available). */
export function isDeliveryAvailable(hoursData) {
  const state = getTodayHoursState(hoursData);
  if (!state.isOpen) return false;

  const buffer = RESTAURANT_SETTINGS.deliveryCloseBufferMinutes ?? 15;
  const deliveryCutoff = state.closeMinutes - buffer;

  return state.nowMinutes <= deliveryCutoff;
}
